export const replaceBuyerInfo = ({ str, type }: { str: string; type: "phone" | "name" }) => {
    if (type === "name") {
        if (str.length < 2) return str;
        return str.slice(0, 1) + "*" + str.slice(2);
    }

    if (type === "phone") {
        return str.replace(/(\d{3})[-]?\d{4}[-]?(\d{4})/, "$1****$2");
    }
};
